export const pick = <T extends Record<string, any>, K extends keyof T>(
    obj: T,
    key: readonly K[],
): Pick<T, K> =>
    key.reduce(
        (prev, curr) => ({
            ...prev,
            // eslint-disable-next-line no-undefined
            ...(obj[curr] !== undefined ? { [curr]: obj[curr] } : {}),
        }),
        {},
    ) as any;
